module.exports = __webpack_public_path__ + "static/media/coming_soon.4cf32473.png";